import React, {useContext} from "react";
import {LanguageContext} from "../context/LanguageContext";
import FeedbackGrid from "../components/common/FeedbackGrid";
import {ReactComponent as NotFoundIcon} from '../assets/images/notFoundIcon.svg';
import {useTheme} from "@mui/material/styles";
import {Box} from "@mui/material";

const PageNotFound = () => {
  const theme = useTheme();
  const languageContext = useContext(LanguageContext);

  return (
    <Box sx={{height: "100%", paddingTop: 10}}>
      <FeedbackGrid
        icon={<NotFoundIcon style={{height: 150, color: theme.palette.secondary.main}}/>}
        label={languageContext.dictionary.notFoundLabel}
        subLabel={languageContext.dictionary.notFoundSubLabel}
      />
    </Box>
  );
};

export default PageNotFound;
